;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();type SentryErrorEvent = {
  tags?: Record<string, unknown>
  exception?: {
    values?: Array<{
      type?: string
      value?: string
      stacktrace?: {
        frames?: Array<{
          module_metadata?: Record<string, unknown>
        }>
      }
    }>
  }
}

const CIRCULAR_JSON_ERROR = "Converting circular structure to JSON"
const ANCHOR_ELEMENT_NAME = "HTMLAnchorElement"
const BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:"
const GOOGLE_IOS_APP_USER_AGENT = /\bGSA\/[\d.]+\b/i
const MAX_CALL_STACK_ERROR = /^Maximum call stack size exceeded\.?$/

function hasApplicationFrame(
  event: SentryErrorEvent,
  applicationKey: string,
): boolean {
  const metadataKey = `${BUNDLER_PLUGIN_APP_KEY_PREFIX}${applicationKey}`

  return Boolean(
    event.exception?.values?.some(({ stacktrace }) =>
      stacktrace?.frames?.some(
        ({ module_metadata: moduleMetadata }) =>
          moduleMetadata?.[metadataKey] === true,
      ),
    ),
  )
}

export function shouldDropKnownGoogleAppInjectedError(
  event: SentryErrorEvent,
  userAgent: string,
  applicationKey: string,
): boolean {
  if (
    !GOOGLE_IOS_APP_USER_AGENT.test(userAgent) ||
    hasApplicationFrame(event, applicationKey)
  ) {
    return false
  }

  return Boolean(
    event.exception?.values?.some(
      ({ type, value }) =>
        (type === "Error" && value === "fa") ||
        (type === "RangeError" &&
          typeof value === "string" &&
          MAX_CALL_STACK_ERROR.test(value)),
    ),
  )
}

export function shouldDropThirdPartyCircularAnchorError(
  event: SentryErrorEvent,
): boolean {
  if (event.tags?.third_party_code !== true) {
    return false
  }

  return Boolean(
    event.exception?.values?.some(
      ({ value }) =>
        typeof value === "string" &&
        value.includes(CIRCULAR_JSON_ERROR) &&
        value.includes(ANCHOR_ELEMENT_NAME),
    ),
  )
}
